"use client";

import React, {
    useEffect,
    useState
} from "react";
import {
    Accordion
} from "react-bootstrap";
import {
    Link,
    useLocation,
    useNavigate

} from "react-router-dom";

const LeftSidebar = ({toggleActive}) => {
    const [activeKey, setActiveKey] = useState("0");
    const location = useLocation(); // Use `useLocation` to get the current path
    const pathname = location.pathname; // Extract `pathname` from location
    const navigate = useNavigate();
    // inside the LeftSidebar component, before the return
    const newFeatureEnabled = process.env.REACT_APP_NEW_FEATURE_ENABLED === "true";


    // Enable the dark sidebar exclusively for the /dashboard/beauty-salon/ page URL.
    const [isDark, setIsDark] = useState(false);

    useEffect(() => {
        // Only check or set the theme if we're on the beauty-salon page.
        if (pathname === "/dashboard/beauty-salon") {
            const storedTheme = localStorage.getItem("beautySalonSidebarTheme");
            if (storedTheme) {
                setIsDark(storedTheme === "dark");
            } else {
                // Default to dark theme and persist it in localStorage
                setIsDark(true);
                localStorage.setItem("beautySalonSidebarTheme", "dark");
            }
        } else {
            // For other pages, do not use localStorage for the theme
            setIsDark(false);
        }
    }, [pathname]);

    const handleLogout = () => {
        localStorage.removeItem("authToken"); // Remove your token key
        toggleActive(); // Close the sidebar
        navigate("/"); // Redirect to sign-in page
    };

    return (
        <>
            <div
                className={`sidebar-area ${pathname === "/dashboard/beauty-salon" && isDark ? "dark" : ""}`}>
                <div
                    className="logo position-relative">
                    <Link
                        to="/dashboard/ecommerce"
                        className="d-block text-decoration-none position-relative"
                    >
                        <img
                            src="/images/tuviendenthanh/favicon.jpg"
                            alt="logo-icon"
                            width={128}
                            height={128}
                        />
                        {/*<span*/}
                        {/*    className="logo-text fw-bold text-dark">O.P.</span>*/}
                    </Link>
                    <button
                        className="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
                        onClick={toggleActive}
                    >
                        <i className="material-symbols-outlined fs-24">close</i>
                    </button>
                </div>

                <div
                    className="sidebar-menu">
                    <div
                        className="menu-title small text-uppercase">
                        <span
                            className="menu-title-text">MAIN</span>
                    </div>

                    <Accordion
                        activeKey={activeKey}
                        onSelect={setActiveKey}
                        defaultActiveKey="0"
                        flush>
                        <Accordion.Item
                            eventKey="0">
                            <Accordion.Header>
                                <i className="material-symbols-outlined">dashboard</i>
                                <span
                                    className="title">Thông tin</span>
                                {/*<span*/}
                                {/*    className="count">30</span>*/}
                            </Accordion.Header>
                            <Accordion.Body>
                                <ul className="sub-menu">


                                    {newFeatureEnabled && (
                                        <li className="menu-item">
                                            <Link
                                                to="/quan-ly-hinh-anh"
                                                className={`menu-link ${pathname === "/quan-ly-hinh-anh" ? "active" : ""}`}
                                            >
                                                Quản lý hình ảnh
                                            </Link>
                                        </li>
                                    )}



                                    <li className="menu-item">
                                        <Link
                                            to="/tuvien/tindang"
                                            className={`menu-link ${
                                                pathname === "/tuvien/tindang" ? "active" : ""
                                            }`}
                                        >
                                            Tin
                                            đăng
                                        </Link>
                                    </li>
                                    <li className="menu-item">
                                        <Link
                                            to="/tuvien/user"
                                            className={`menu-link ${pathname === "/tuvien/user" ? "active" : ""}`}
                                        >
                                            Người
                                            dùng
                                        </Link>
                                    </li>
                                    {/*<li className="menu-item">*/}
                                    {/*    <Link*/}
                                    {/*        to="/tuvien/suatindang"*/}
                                    {/*        className={`menu-link ${*/}
                                    {/*            pathname === "/tuvien/suatindang" ? "active" : ""*/}
                                    {/*        }`}*/}
                                    {/*    >*/}
                                    {/*        Sửa*/}
                                    {/*        tin*/}
                                    {/*        đăng*/}
                                    {/*    </Link>*/}
                                    {/*</li>*/}

                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>
                        <div
                            className="menu-item">
                            <button
                                type="button"
                                className={`menu-link ${pathname === "/authentication/logout" ? "active" : ""}`}
                                onClick={handleLogout}
                                style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    width: "100%",
                                    textAlign: "left"
                                }}
                            >
                                <i className="material-symbols-outlined">logout</i>
                                <span
                                    className="title">Logout</span>
                            </button>
                        </div>
                    </Accordion>
                </div>
            </div>
        </>
    );
};

export default LeftSidebar;
